import React from "react";
import GoogleChart from "../../../../components/charts/googleChart/googleChart";
import { useSelector } from "react-redux";

const TableChart = () => {
  const { rows = [], cols = [] } = useSelector(
    (state) => state.numberOfActiveMembersBy.tableChartData
  );

  return (
    <GoogleChart
      addColor
      chartName=""
      width="1350px"
      chartType="Table"
      rows={rows}
      columns={cols}
      enableEventListeners
      isTableView
      showXLSX
      options={{ showRowNumber: true, frozenColumns: 1 }}
      showAdditionTooltip={false}
    />
  );
};

export default TableChart;
